<template>
  <SimpleModuleDashboard
    :module-id="Modules.FINANZAS"
    :profile-id="Profiles.PERSONAL"
    include-php-custom
    :actions="actions"
  />
</template>

<script>
import Profiles from '@/config/profiles'
import Modules from '@/config/modules'
import SimpleModuleDashboard from '@/components/inc/dashboard/SimpleModuleDashboard'

export default {
  components: { SimpleModuleDashboard },
  data: () => ({
    Modules,
    Profiles,
    actions: [
      { id: 'settings', reference: 'settings', route: 'FinancesStaffSettings', tone: 'primary' },
      { id: 'cashDetail', reference: 'cashDetail', route: 'FinancesStaffCashDetail', tone: 'primary' },
      { id: 'cheques', reference: 'cheques', route: 'FinancesStaffCheques', tone: 'success' },
    ],
  }),
}
</script>
